export const VirtualPagePaths = {
	DE: {
		// Login flow
		AUTO_LOGIN: '/ratenkredit/auto-login',
		AUTO_LOGIN_ERROR: '/ratenkredit/auto-login-error',
		LOGIN_START_FORM: '/ratenkredit/login-start-form',
		LOGIN_OTP_FORM: '/ratenkredit/login-otp-form',
		LOGIN_ERROR: '/ratenkredit/login-error',
		LOGIN_COMPLETE: '/ratenkredit/login-complete',
		// Application steps
		PERSONAL_DATA: '/ratenkredit/personal-data',
		PSD2: '/ratenkredit/psd2',
		LOAN_OFFER: '/ratenkredit/loan-offer',
		SIGN_PN: '/ratenkredit/sign-pn',
		UPLOAD_DOCUMENTS: '/ratenkredit/upload-documents',
		THANK_YOU: '/ratenkredit/thank-you',
		DISBURSED: '/ratenkredit/disbursed',
		REVIEWED: '/ratenkredit/reviewed',
	},
} as const
